import React, { useState, useEffect } from 'react';
import { Container, Header, Title, Text, Button, Icon, Footer, Left, Body, Right, ListItem, Content, Separator, View, Card, CardItem, Toast, Tabs, Tab } from 'native-base';
import { Platform, Linking, WebView, StyleSheet } from 'react-native';
//import { NavigationEvents } from 'react-navigation';
import CalCalDataApi from '../../api/CalCalDataApi';
import Modal from '../../components/modal';
import StepIndicator from 'react-native-step-indicator';

import SaPrePop from './saPrePop';
import SelItem from './selItem';
import WhatSubmitted from './whatSubmitted';
import Attachments from './attachments';
import Alert from '../../components/alert';
import TawkToButton from '../../components/tawkto';

/*
const indicatorStyles = {
	stepIndicatorSize: 30,
	currentStepIndicatorSize: 40,
	separatorStrokeWidth: 2,
	currentStepStrokeWidth: 3,
	stepStrokeCurrentColor: '#fe7013',
	stepStrokeWidth: 3,
	separatorStrokeFinishedWidth: 4,
	stepStrokeFinishedColor: '#fe7013',
	stepStrokeUnFinishedColor: '#aaaaaa',
	separatorFinishedColor: '#fe7013',
	separatorUnFinishedColor: '#aaaaaa',
	stepIndicatorFinishedColor: '#fe7013',
	stepIndicatorUnFinishedColor: '#ffffff',
	stepIndicatorCurrentColor: '#ffffff',
	stepIndicatorLabelFontSize: 13,
	currentStepIndicatorLabelFontSize: 13,
	stepIndicatorLabelCurrentColor: '#fe7013',
	stepIndicatorLabelFinishedColor: '#ffffff',
	stepIndicatorLabelUnFinishedColor: '#aaaaaa',
	labelColor: '#999999',
	labelSize: 13,
	currentStepLabelColor: '#fe7013',
};*/

function currency(val, dec = true) {
	//if (typeof val != 'number') return '';
	val = Number(val);
	if (typeof val != 'number') return '';
	const numDec = dec ? 2 : 0;
	return val < 0 ? '- £' + Math.abs(val).toFixed(numDec) : '£' + val.toFixed(numDec);
}

export default function SaSubmissionContainer({ year, navigation, jwt }) {
	//console.log(year);
	if (year.id < 2019)
		return (
			<Container>
				<Header>
					<Left>
						<Button transparent onPress={() => navigation.goBack()}>
							<Icon active name="ios-arrow-back" />
						</Button>
					</Left>
					<Body>
						<Title>SA Submission</Title>
						<Text style={styles.headerTxt}>{year.text}</Text>
					</Body>
					<Right />
				</Header>
				<Content padder>
					<Button bordered onPress={() => (window.location = 'https://calc.al/app/#tax')}>
						<Text>Please use the old app to edit your tax return</Text>
						<Icon active name="ios-arrow-forward" />
					</Button>
				</Content>
			</Container>
		);
	//console.log(year);
	const [forms, setForms] = useState(false); //forms is false to start, empty array on loading
	const [doRefresh, setDoRefresh] = useState(false); //returned from a form. Do check - live connection ok? At least 1 form a
	const [error, setError] = useState(null);
	const [visited, setVisited] = useState([]);
	const [showYourSubmission, setShowYourSubmission] = useState(false);
	const [ticks, setTicks] = useState({});
	const [calcAmount, setCalcAmount] = useState();
	const [step, setStep] = useState(0);
	//console.log(forms, visited);
	useEffect(() => {
		const unsubscribe = navigation.addListener('focus', () => {
			setDoRefresh(true);
		});

		return unsubscribe;
	}, [navigation]);

	useEffect(() => {
		//sync figures to return
		//wait - what if this has been submitted and is waiting?
		if (year.submitted && year.status == 'waiting') {
			setShowYourSubmission(true);
		} else {
			CalCalDataApi.dataLoad('sa/' + year.id + '/sync', jwt, res => {
				res.success && Toast.show({ text: 'Imported figures from your CalCal data', position: 'bottom', type: 'success', duration: 5000, buttonText: 'Okay' });
			});
		}
	}, []);

	const [validationErrors, setValidationErrors] = useState([]);
	const [attachmentCount, setAttachmentCount] = useState(0);
	useEffect(() => {
		if (doRefresh || (forms === false && !error))
			CalCalDataApi.dataLoad('sa/' + year.id + '/forms', jwt, res => {
				//if (__DEV__) console.log(res);
				setDoRefresh(false);
				if (!res.error) {
					setForms(res.forms.filter(f => f.show));
					setTicks(res.otherticks); //connect and details
					setAttachmentCount(res.attachments);
					setError(null);
				} else {
					setError({ loading: 'forms', error: typeof res.error == 'text' ? res.error : res.message });
				}
			});

		if (doRefresh && visited.length)
			CalCalDataApi.dataLoad('sa/' + year.id + '/calc', jwt, res => {
				//calc checks XML too, but you shouldn't have managed to get out of your form!
				if (res && res.success) {
					setCalcAmount(res.calc_amount);
					setValidationErrors([]);
				} else {
					setValidationErrors(res.result);
					setCalcAmount(null);
					Toast.show({
						text: 'Calculation error',
						buttonText: 'Okay',
						duration: 5000,
						position: 'bottom',
						type: 'danger'
					});
				}
			});
	}, [doRefresh]);

	const navToForm = (form, doCheck) => {
		visited.includes(form) || form == 'YPD' || form == 'YourReturn' || setVisited([...visited, form]);
		navigation.navigate('SaForm', !!doCheck ? { y: year.taxyear, year: year.text, form, doCheck } : { y: year.taxyear, year: year.text, form }); // just keeping the UYRL clean
	};

	const [showAttachments, setShowAttachments] = useState(false);

	return (
		<Container>
			<Modal
				isOpen={showYourSubmission || showAttachments}
				//backButtonClose
				backdropPressToClose={false}
				swipeToClose={false}
				coverScreen
				swipeArea={100}
				//swipeThreshold={0}
				onClosed={() => setShowYourSubmission(false)}
				style={{
					height: '95%',
					width: '95%',
					justifyContent: 'center'
				}}
				//backdropOpacity={0.7}
				useNativeDriver>
				{showYourSubmission && <WhatSubmitted jwt={jwt} navigation={navigation} year={year.id} close={() => setShowYourSubmission(false)} alreadySent={year.submitted} />}
				{showAttachments && (
					<Attachments
						jwt={jwt}
						year={year.id}
						close={() => {
							setShowAttachments(false);
							setDoRefresh(true);
						}}
					/>
				)}
			</Modal>
			<Header>
				<Left>
					<Button transparent onPress={() => navigation.goBack()}>
						<Icon active name="ios-arrow-back" />
					</Button>
				</Left>
				<Body>
					<Title>SA Submission</Title>
					<Text style={styles.headerTxt}>{year.text}</Text>
				</Body>
				<Right>
					<TawkToButton />
				</Right>
			</Header>
			<Content>
				{!calcAmount && !validationErrors.length && year.status == 'error' && (
					<ListItem key={0} itemDivider style={{ backgroundColor: '#faa' }}>
						<Text styles={styles.white}>Previous submission error - Review and resubmit</Text>
					</ListItem>
				)}
				{!calcAmount && year.status == 'amending' && (
					<ListItem key={1} itemDivider style={{ backgroundColor: '#ffffad' }}>
						<Text styles={styles.white}>Amending previous submission</Text>
					</ListItem>
				)}
				{!!error && (
					<ListItem key={2} itemDivider style={{ backgroundColor: '#E66' }}>
						<Text>
							Error loading {error.loading}: {error.error}
						</Text>
					</ListItem>
				)}
				{!!calcAmount && (
					<ListItem key={3} itemDivider style={{ backgroundColor: '#BFB' }} onPress={() => setShowYourSubmission(true)}>
						<Left>
							<Text>Owed: {currency(calcAmount)}</Text>
						</Left>
						<Body>
							<Text note>See calculation</Text>
						</Body>
						<Right>
							<Icon name="arrow-forward" />
						</Right>
					</ListItem>
				)}
				{validationErrors.length > 0 &&
					validationErrors.map((v, i) => (
						<ListItem
							key={`er${i}`}
							itemDivider
							style={{ backgroundColor: '#faa' }}
							onPress={() => {
								v.form && v.form != 'UKN' && navToForm(v.form, true);
							}}>
							<Body>
								<Text>Error in {v.error_type}</Text>
								<Text>{v.nice_box}</Text>
								<Text note>{v.error_msg}</Text>
							</Body>
							<Right>
								<Text>{v.box_name}</Text>
								{v.form && v.form != 'UKN' && <Icon style={{ color: '#000' }} name="arrow-forward" />}
							</Right>
						</ListItem>
					))}
				<View padder />
				<StepIndicator
					stepCount={3}
					//customStyles={thirdIndicatorStyles}
					currentPosition={step}
					onPress={setStep}
					labels={['Set up', 'Your forms', 'Complete return']}
				/>
				<Tabs
					initialPage={0}
					prerenderingSiblingsNumber={2}
					style={{ flex: 1 }}
					page={step}
					onScroll={s => {
						s % 1 == 0 && setStep(s);
					}}
					renderTabBar={tabProps => <View />}>
					<Tab heading="Setup">
						<Separator style={{ maxHeight: 32 }}>
							<Text style={{ fontSize: 20 }}>Get set up</Text>
						</Separator>

						<SelItem icon="checkmark" text="Your Details" colour={ticks.details ? '#080' : '#DDD'} onPress={() => navToForm('YPD')} rText={!ticks.details ? 'Tap me' : ' '} />
						<SelItem icon="checkmark" text="Pre-fill Forms" colour={ticks.pre ? '#080' : '#DDD'} onPress={() => navToForm('PREFILL')} rText={!ticks.pre ? 'Tap me' : ' '} />
						{ticks.utr && <SaPrePop jwt={jwt} navigation={navigation} taxyear={year.id} />}
						<View padder>
							<Button bordered style={{ alignSelf: 'flex-end' }} onPress={() => setStep(1)} disabled={!ticks.details}>
								<Text>Step 2</Text>
								<Icon name="arrow-forward" />
							</Button>
						</View>
					</Tab>
					<Tab heading="fill">
						<Separator style={{ maxHeight: 44 }}>
							<Text style={{ fontSize: 20 }}>Fill out your forms</Text>
							<Text note>Tap each form to open it</Text>
						</Separator>
						{forms &&
							forms.map((form, i) => {
								return (
									form.show && (
										<SelItem
											key={i}
											onPress={() => navToForm(form.name)}
											icon={form.error ? 'alert' : 'checkmark'}
											rText={form.name}
											rSubText={form.display}
											text={form.sa}
											colour={form.error ? '#911' : form.done || visited.includes(form.name) ? '#080' : '#DDD'}
										/>
									)
								);
							})}
						<View padder style={{ flexDirection: 'row' }}>
							<Left>
								<Button iconLeft primary onPress={() => navToForm('YourReturn')}>
									<Icon name="ios-add-circle-outline" />
									<Text>Select forms</Text>
								</Button>
							</Left>
							<Right>
								<Button iconRight bordered onPress={() => setStep(2)} disabled={forms.length <= 1 || !ticks.details || !calcAmount}>
									<Text>Step 3</Text>
									<Icon name="arrow-forward" />
								</Button>
							</Right>
						</View>
					</Tab>
					<Tab heading="Complete">
						<Separator style={{ maxHeight: 32 }}>
							<Text style={{ fontSize: 20 }}>Complete your return</Text>
						</Separator>

						<SelItem icon="calculator" text="Calculation & Adjustments" colour={visited.includes('CAL') ? '#33E' : '#DDD'} onPress={() => navToForm('CAL')} />
						<SelItem
							icon="md-document"
							text="Attach Files"
							colour={attachmentCount ? '#080' : '#DDD'}
							onPress={() => setShowAttachments(true)}
							rText={attachmentCount > 0 && attachmentCount.toString() + ' attached'}
						/>
						<SelItem text="Finish Off" icon="send" colour={visited.includes('FIN') ? '#000' : '#DDD'} onPress={() => navToForm('FIN')} />
						<View padder />
						<Button disabled={!calcAmount} bordered iconRight style={{ alignSelf: 'flex-end' }} onPress={() => setShowYourSubmission(true)}>
							<Text>Check and Send</Text>
							<Icon name="arrow-forward" />
						</Button>
					</Tab>
				</Tabs>
			</Content>
			{false && (
				<Footer style={{ backgroundColor: '#7AF' }}>
					<Left>
						<Text>Est'd Liability</Text>
					</Left>
					<Right>
						<Button style={{ margin: 15 }}>
							<Text>View Calc</Text>
						</Button>
					</Right>
				</Footer>
			)}
		</Container>
	);
}

const styles = StyleSheet.create({
	headerTxt: {
		color: '#EEE'
	},
	rightText: {
		textAlign: 'right',
		fontSize: 14
	},
	rightTextSmall: {
		textAlign: 'right',
		fontSize: 11
	},
	white: { color: '#FFF' }
});
